var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9922 0.78125C16.1875 0.585938 16.5 0.585938 16.6562 0.78125L17.7891 1.875C17.9453 2.07031 17.9453 2.38281 17.7891 2.53906L6.07031 14.2578C5.875 14.4531 5.60156 14.4531 5.40625 14.2578L0.171875 9.0625C0.015625 8.86719 0.015625 8.55469 0.171875 8.39844L1.30469 7.26562C1.46094 7.10938 1.77344 7.10938 1.96875 7.26562L5.71875 11.0547L15.9922 0.78125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.5fea2c839422a206ca6518cbe9ad134b.svg";
export { ForwardRef as ReactComponent };